<nav class="mobile-nav">
  @for (item of mobileNavService.mainNavItems(); track item.id) {
    <a [routerLink]="item.route" 
       routerLinkActive="active" 
       class="mobile-nav-item">
      <i class="bi" [class]="item.icon"></i>
      <span>{{ item.label }}</span>
    </a>
  }
  
  <a (click)="mobileNavService.toggleMore()" 
     class="mobile-nav-item"
     [class.active]="mobileNavService.isMoreOpen()">
    <i class="bi bi-three-dots"></i>
    <span>Más</span>
  </a>
</nav>

<!-- More Menu Overlay -->
<div class="more-menu-overlay" 
     [class.visible]="mobileNavService.isMoreOpen()"
     (click)="mobileNavService.closeMore()"></div>

<!-- More Menu Content -->
<div class="more-menu" [class.open]="mobileNavService.isMoreOpen()">
  <div class="more-menu-header">
    <h3>Opciones adicionales</h3>
    <button (click)="mobileNavService.closeMore()" class="btn-close-menu">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
  
  <div class="more-menu-content">
    @for (item of mobileNavService.moreNavItems(); track item.id) {
      <a [routerLink]="item.route" 
         routerLinkActive="active" 
         class="more-menu-item"
         (click)="mobileNavService.closeMore()">
        <i class="bi" [class]="item.icon"></i>
        <span>{{ item.label }}</span>
      </a>
    }
  </div>
</div>
